import {
  getRecurring,
  RecurringResponse,
  SuccessResponse,
} from '@back-office/http';
import { FlowReturn } from 'mobx-state-tree/dist/core/flow';
import { ResponseMessage } from '../../constants';
import { handleNotAuthorized, Self } from '../common';

function* recurringDetailRequest(
  self: Self,
  recurringId: string
): Generator<Promise<FlowReturn<RecurringResponse>>> {
  self.isLoading = true;
  try {
    const response = yield getRecurring(recurringId);
    const { data, status } = (response as RecurringResponse).data;
    if (status.code === 1000) {
      self.recurringDetail.reset();
      self.recurringDetail = {
        ...self.recurringDetail,
        ...data?.GetRecurringRequestByIDForSubMerchant,
      };
      return Promise.resolve(ResponseMessage.OK);
    }
    if (status.code === 9500) {
      return handleNotAuthorized(self, response as SuccessResponse);
    }
    self.alert.title = status.messages[0];
    self.alert.open = true;
    return Promise.reject(new Error(ResponseMessage.Error));
  } catch (e) {
    self.alert.title = 'login_form.internal_server_error';
    self.alert.open = true;
    return Promise.reject(new Error(e.message));
  } finally {
    self.isLoading = false;
  }
}

export default recurringDetailRequest;
